import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { TileDescriptor } from './TileDescriptor';
import { CurrentUserService } from '../../../security/services/CurrentUserService';

@Injectable()
export class DashboardTilesRegistry {
  private registry = new Map<string, BehaviorSubject<TileDescriptor[]>>();

  constructor(private currentUserService: CurrentUserService) {

  }

  registerTile(dashboard: string, tileDescriptor: TileDescriptor): void {
    var subject = this.getSubject(dashboard);
    subject.next(subject.getValue().concat([tileDescriptor]));
  }

  getTiles(dashboard: string, tab: string = null): Observable<TileDescriptor[]> {
    var subject = this.getSubject(dashboard);
    return subject.asObservable().map(tiles => tiles.filter(
        t => this.currentUserService.hasPermission(t.permission) && t.displayName === tab).sort(this.sortTiles));
  }

  private sortTiles(tile1: TileDescriptor, tile2: TileDescriptor): number {
    if (tile1.priorityOrder < tile2.priorityOrder)
      return -1;
    if (tile1.priorityOrder > tile2.priorityOrder)
      return 1;
    return 0;
  }

  private getSubject(dashboard: string): BehaviorSubject<TileDescriptor[]> {
    if (!this.registry.has(dashboard)) {
      this.registry.set(dashboard, new BehaviorSubject([]));
    }
    return this.registry.get(dashboard);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/services/DashboardTilesRegistry.ts